// @flow
import injectSheet from 'react-jss';
import skin from './skin';
import theme from './theme';

// NOTE: [MC] typings now come from react-jss flow-typed, but I imagine our useSheet functions needs to pass through types
// to make it work. So leaving these commented as they will assist in doing this.

// type StatelessComponent<P> = (props: P) => ?React$Element<any>;
//
// type Classes<CSS> = {
//   [classname: $Keys<CSS>]: string,
// };
//
// type AddedProps<CSS> = {
//   classes: Classes<CSS>,
//   sheet: {
//     attached: boolean,
//     classes: Classes<CSS>,
//     deployed: boolean,
//     linked: boolean,
//     options: Object,
//     renderer: mixed,
//     rules: mixed,
//   },
// };
//
// type Injector<P, Def, S, CSS> = {
//   (component: StatelessComponent<P>): Class<React$Component<void, $Diff<P, AddedProps<CSS>>, void>>;
//   <Def, St>(
//     component: Class<React$Component<Def, P, St>>,
//   ): Class<React$Component<void, $Diff<P, AddedProps<CSS>>, void>>;
// };

// function useSheet<OP, Def, S, CSS>(
//   styling: (theme: Object, skin?: Object) => CSS,
// ): Injector<OP, Def, S, CSS> {
//   const styles = styling(theme, skin);
//   return injectSheet(styles);
// }

function useSheet(styling: (theme: Object, skin?: Object) => any) {
  const styles = styling(theme, skin);
  return injectSheet(styles);
}

export default useSheet;
